export default __webpack_public_path__ + "static/media/pv_composition2.c3f894a0.jpg";